import classNames from "components/ui/classNames";
import Link from "next/link";
import { SearchStateConsumer } from "../../lib/algolia/SearchStateContext";
import { IAssetType } from "../../types/graphqlTypes";
import { encodeSearchState, withSelectedIndustrySector } from "../screener/searchState";

interface IndustrySectorProps {
  assetType: IAssetType;
  industrySector: string;
  className?: string;
}

export default function IndustrySector({ assetType, industrySector, className }: IndustrySectorProps) {
  const searchState = withSelectedIndustrySector(assetType, industrySector);
  const encodedSearchState = encodeSearchState(searchState);

  return (
    <SearchStateConsumer>
      {({ setSearchState }) => (
        <Link
          href={`/?searchState=${encodedSearchState}`}
          title={industrySector}
          onClick={() => setSearchState(searchState)}
          className={classNames(
            "text-blue font-aeonik text-sm font-medium text-blue-600 no-underline hover:underline",
            className,
          )}
        >
          {industrySector}
        </Link>
      )}
    </SearchStateConsumer>
  );
}

interface NareitClassificationSectorProps {
  propertySector: string;
  propertySubsector: string | null;
  className?: string;
}

export function NareitClassificationSector({
  propertySector,
  propertySubsector,
  className,
}: NareitClassificationSectorProps) {
  const propertySectorAndSubsector =
    propertySector && propertySubsector ? `${propertySector} - ${propertySubsector}` : propertySector;
  const searchState = {
    menu: {
      type: IAssetType.AmericanReit,
    },
    page: 1,
    configure: {
      maxValuesPerFacet: 20,
      hitsPerPage: 24,
    },
    refinementList: {
      "nareitClassification.propertySectorAndSubsector": propertySectorAndSubsector,
    },
  };
  const encodedSearchState = encodeSearchState(searchState);

  return (
    <SearchStateConsumer>
      {({ setSearchState }) => (
        <Link
          href={`/?searchState=${encodedSearchState}`}
          title={propertySectorAndSubsector}
          onClick={() => setSearchState(searchState)}
          className={classNames(
            "text-blue font-aeonik text-sm font-medium text-blue-600 no-underline hover:underline",
            className,
          )}
        >
          {propertySectorAndSubsector}
        </Link>
      )}
    </SearchStateConsumer>
  );
}
